module.exports = __webpack_public_path__ + "files/b0aa0b6897192adae4e406e08a2d1a6e.png";